import { render, staticRenderFns } from "./BusinessNameDataUpdateAttachments.vue?vue&type=template&id=e57b3be2&scoped=true&"
import script from "./BusinessNameDataUpdateAttachments.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateAttachments.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateAttachments.vue?vue&type=style&index=0&id=e57b3be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57b3be2",
  null
  
)

export default component.exports